import React, { useState } from 'react'
import api from '../components/api'

const Login = () => {

    console.log(process.env.REACT_APP_API)

    var [login, setLogin] = useState('')
    var [senha, setSenha] = useState('')


    async function loginAdm() {

        if (login == '') {

            window.toastr.error('<b>Login</b> inválido!')
            return false

        }

        if (senha == '') {


            window.toastr.error('<b>Senha</b> inválida!')
            return false

        }

        var dataPost = {

            login: login,
            senha: senha,

        }

        //console.log(dataPost)


        await api.post('loginAdm', dataPost).then((result) => {

            //console.log(result.data)
            //return false

            if (result.data[0].us_codigo) {

                //console.log(result.data[0].nome)
                sessionStorage.setItem('us_codigo', result.data[0].us_codigo)
                sessionStorage.setItem('nome', result.data[0].nome)
                sessionStorage.setItem('autenticado', true)

                sessionStorage.setItem('permAdmin', result.data[0].permAdmin)
                sessionStorage.setItem('permDesafios', result.data[0].permDesafios)
                sessionStorage.setItem('permEventos', result.data[0].permEventos)
                sessionStorage.setItem('permNoticias', result.data[0].permNoticias)
                sessionStorage.setItem('permPaginas', result.data[0].permPaginas)
                sessionStorage.setItem('permAdesoes', result.data[0].permAdesoes)
                sessionStorage.setItem('permSenhaInst', result.data[0].permSenhaInst)
                
                
                window.location.href = '/Dashboard'

            } else {

                window.toastr.error('Login ou senha inválida!')
                return false

            }


        }).catch((err) => {

            window.toastr.error('Login ou senha inválida!')
            console.log(err.response)

        })


       
        


    }

    


    return (

        <div>

            
                  
                    <div className="login-wrapper">
                        <div className="container-center">
                            <div className="panel panel-bd">
                                
                                <div className="panel-body">
                                    
                                        
                                        <div className="social">
                                            <center>
                                            <img src={process.env.PUBLIC_URL + 'assets/pics/logo_HS.png'} alt="" width="150" />
                                            </center>

                                        </div>
                                        <div className="form-group">
                                            <label className="control-label">Login</label>
                                            <div className="input-group">
                                                <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                                                <input id="username" type="text" className="form-control" placeholder="Login" onChange={event => setLogin(event.target.value)} value={login} />
                                            </div>
                                            <span className="help-block small" style={{ display: 'none'}}>Informe seu CPF</span>
                                        </div>
                                        <div className="form-group">
                                            <label className="control-label">Senha</label>
                                            <div className="input-group">
                                                <span className="input-group-addon"><i className="fa fa-key"></i></span>
                                                <input id="pass" type="password" className="form-control"  placeholder="Senha" onChange={event => setSenha(event.target.value)} value={senha} />
                                            </div>
                                            
                                        </div>
                                        <div>
                                            <button className="btn btn-primary pull-right" onClick={() => loginAdm()}>Login</button>
                                            <div className="checkbox checkbox-success" style={{ display: 'none' }}>
                                                <input id="checkbox3" type="checkbox" />
                                                <label for="checkbox3">Keep me signed in</label>
                                            </div>
                                        </div>
                                    
                                </div>
                            </div>
                            

                        </div>
                    </div>
                    
                
                    

        </div>


    )

}

export default Login